import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/auth/AuthContext'
import { isStaffRole } from '@/lib/roles'
import { LoadingState } from './ui'

export function ProtectedRoute() {
  const { user, isAuthenticated, bootstrapping } = useAuth()
  const location = useLocation()

  if (bootstrapping) return <LoadingState label="Restoring session…" />
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  const roles = user.roles ?? []
  const path = location.pathname
  const staff = isStaffRole(roles) || roles.includes('SuperAdmin')

  if (!staff && path !== '/access-denied') {
    return <Navigate to="/access-denied" replace />
  }

  return <Outlet />
}
